import { AdmService } from '../../../shared/services/adm.service';
import { Component, Inject, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { debounceTime, distinctUntilChanged, filter, finalize, forkJoin, map, startWith, switchMap, tap } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { isMobile, isMobileXL } from 'src/app/shared/utils/helpers';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Parametro } from 'src/app/shared/models/parametro';
import { ParametrosService } from '../../../shared/services/parametros.service';
import { Router } from '@angular/router';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';

@Component({
    selector: 'app-parametros-dialog',
    templateUrl: './parametros-dialog.component.html'
})
export class ParametrosDialogComponent implements OnInit {
    form: FormGroup;
    dataADevolver: Parametro = null;
    idTipo: number;
    codigoParametroEdit: number = -1;


    constructor(private configService: ConfigService,
        private admService: AdmService,
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<ParametrosDialogComponent>,
        private fb: FormBuilder,
        private loggedService: LoggedService,
        private parametroService: ParametrosService,
        private router: Router,
        private sidenav: SidenavService,
        private snackBarService: SnackbarService,

        @Inject(MAT_DIALOG_DATA) private data: any) {
        this.form = this.fb.group({
            codigo: [''],
            descripcion: ['', [Validators.required, Validators.maxLength(50)]],
            habilitacion: [true],
            id: ['', [
                Validators.required,
                Validators.pattern('[0-9]|1[0-9]|2[0-4]')
            ]]
        })

        if (data.idTipo != null) {
            this.idTipo = data.idTipo;
        }
        if (data.parametro != null) {
            this.codigoParametroEdit = data.parametro.codigo;
        }
    }
    public Etiquetas: {
        Id: string,
        Descripcion: string,
        Habilitacion: string
    }

    public Validaciones: {
        Id: string,
        IdNumero: string,
        Descripcion: string
    }
    ngOnInit(): void {
        this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.dataADevolver));

        this.Etiquetas = {
            Id: this.configService.etiquetas.Id,
            Descripcion: this.configService.etiquetas.Descripcion,
            Habilitacion: this.configService.etiquetas.Habilitacion
        }

        this.Validaciones = {
            Descripcion: this.configService.validaciones.Descripcion,
            Id: this.configService.validaciones.Id,
            IdNumero: this.configService.validaciones.IdNumero
        }

        if (this.idTipo == 2) {
            this.parametroService.cParametroDB(this.codigoParametroEdit).subscribe((data: Parametro) => {
                if (data != null) {

                    this.form.controls['id'].setValue(data.id);
                    this.form.controls['descripcion'].setValue(data.descripcion);
                    this.form.controls['codigo'].setValue(data.codigo);
                    this.form.controls['habilitacion'].setValue(data.habilitacion);
                    this.form.markAsUntouched();
                    this.form.markAsPristine();
                }
            });

            if (this.loggedService.isInRole("CONSULTOR")) {
                this.form.disable();
            }
        }
    }
    guardarParametro() {
        switch (this.idTipo) {
            case 1:
                this.form.controls['codigo'].setValue('0');
                this.parametroService.aParametro(this.form.value).subscribe((data: Parametro) => {
                    this.dataADevolver = data;
                    this.dialogRef.close(this.dataADevolver);
                });
                break;

            case 2:
                this.parametroService.mParametro(this.form.value).subscribe((data: Parametro) => {
                    this.dataADevolver = data;
                    this.dialogRef.close(this.dataADevolver);
                });
                break;
        }
    }

    clearInput(formControlName: string) {
        this.form.controls[formControlName].reset();
    }

    isMobileXL() {
        return isMobileXL();
    }

    isMobile() {
        return isMobile();
    }
    isInRole(rol: string): boolean {
        return this.loggedService.isInRole(rol);
    }
}
